/**
 * A non-native implementation of 'path' import utilities (needed instead of polyfill)
 *
 * @param parts Strings to join
 */
export const joinPath = (...parts) => {
    const separator = '/';
    const replace = new RegExp(`${separator}{1,}`, 'g');
    const path = parts.join(separator).replace(replace, separator);
    return path.endsWith(separator) ? path.slice(0, path.length - 1) : path;
};
//# sourceMappingURL=common.js.map